<template>
  <label>
    {{ $t('formPackage.roomQty') }}
  </label>
</template>
